export const RELATIVE_POSITION = 'relative';
export const BOTTOM_LC = 'cornerLeftBottom';
export const TOP_LC = 'cornerLeftTop';
export const TOP_RC = 'cornerRightTop';
export const BOTTOM_RC = 'cornerRightBottom';
export const TOP_LC_M = 'cornerLeftTopM';
export const TOP_LC_S = 'cornerLeftTopS';
